import { render, staticRenderFns } from "./stickers-sum-view.vue?vue&type=template&id=6c4c6f7a&scoped=true"
import script from "./stickers-sum-view.vue?vue&type=script&lang=js"
export * from "./stickers-sum-view.vue?vue&type=script&lang=js"
import style0 from "./stickers-sum-view.vue?vue&type=style&index=0&id=6c4c6f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4c6f7a",
  null
  
)

export default component.exports